import { Wrench, Inbox, FileWarning } from "lucide-react";
import { ServiceLanding } from "@/components/ServiceLanding";

const cfg = {
  prefix: "quickbooks-cleanup",
  pageTitle: "QuickBooks Cleanup & Catch-Up Services | CalCor Solutions, Seattle",
  topbarLabel: "QuickBooks cleanup · Seattle & remote",
  eyebrow: "QuickBooks Cleanup & Catch-Up",
  heroTitle: (
    <>
      Messy QuickBooks file? <em className="text-pine">Consider it cleaned.</em>
    </>
  ),
  heroSub:
    "CalCor Solutions takes QuickBooks files that are months — or years — behind and hands back a clean, reconciled, trustworthy set of books. One project, one fixed quote, no judgment. Based in Seattle, serving clients remotely everywhere.",
  formHeading: "Start with a free file review.",
  formSub: "Tell us how far behind things are — we'll tell you exactly what it takes to fix.",
  messageLabel: "How messy are we talking? *",
  formPlaceholder: "e.g. Eight months behind, duplicate accounts everywhere, bank feed hasn't been reconciled since last year…",
  submitLabel: "Get my cleanup quote",
  quoteCta: "Get a fixed-fee quote",
  serviceValue: "QuickBooks cleanup",
  audienceHeading: (
    <>
      Built for files <em className="text-pine">in every kind of mess.</em>
    </>
  ),
  audiences: [
    {
      icon: Inbox,
      title: "Months (or years) behind",
      desc: "The backlog isn't a character flaw — it's a capacity problem. We catch you up completely, then keep you current if you want.",
    },
    {
      icon: FileWarning,
      title: "Inherited a mess",
      desc: "New owner, new bookkeeper, new finance director — and a file nobody can explain. We reconstruct, reconcile, and document everything.",
    },
    {
      icon: Wrench,
      title: "DIY files that drifted",
      desc: "Duplicate accounts, miscategorized transactions, mystery balances. We untangle it and leave a file that finally makes sense.",
    },
  ],
  includedHeading: (
    <>
      Every mess, <em className="text-pine">systematically undone.</em>
    </>
  ),
  includedSub:
    "A fixed-fee project with a clear finish line: a clean file, a record of what changed, and books you can finally trust.",
  included: [
    "Full diagnostic review of your QuickBooks file",
    "Bank and credit card reconciliations brought current",
    "Duplicate and miscategorized transactions fixed",
    "Chart of accounts cleaned and streamlined",
    "Opening balances and equity corrected",
    "A written record of everything we changed",
    "Fixed-fee quote before we touch anything",
    "Optional handoff to ongoing monthly bookkeeping",
  ],
  testimonialsHeading: (
    <>
      Fifteen years of <em className="text-pine">rescued files.</em>
    </>
  ),
  testimonials: [
    {
      quote: "CalCor untangled two years of messy books in a single quarter. Our lender actually complimented the reporting package.",
      by: "Owner, family-run retail group",
      where: "Tacoma, WA",
    },
    {
      quote: "Every month closes on time, every report makes sense, and tax season stopped being a fire drill.",
      by: "Founder, growing e-commerce business",
      where: "Seattle, WA",
    },
    {
      quote: "They answer in plain English, hit every deadline, and our board finally understands the numbers.",
      by: "Executive Director, regional nonprofit",
      where: "Seattle, WA",
    },
  ],
  finalTitle: (
    <>
      Hand us the mess. <em className="text-paper/70">Get back a clean file.</em>
    </>
  ),
  finalSub:
    "Tell us how far behind the file is. You will hear back within one business day with a clear scope and a fixed quote — no judgment, no jargon.",
};

export default function QuickBooksCleanup() {
  return <ServiceLanding cfg={cfg} />;
}
